import { render, staticRenderFns } from "./SelectRules.vue?vue&type=template&id=cf822254&scoped=true"
import script from "./SelectRules.vue?vue&type=script&lang=ts"
export * from "./SelectRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf822254",
  null
  
)

export default component.exports